export const weekDays = ['일', '월', '화', '수', '목', '금', '토']
